<template>
  <div>
    <input
      type="text"
      :value="displayedDate"
      @input="onInput"
      maxlength="10"
      placeholder="DD-MM-AAAA"
    />
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      default: "",
    },
  },
  computed: {
    displayedDate() {
      if (this.modelValue) {
        const [year, month, day] = this.modelValue.split("-");
        return `${day || ""}-${month || ""}-${year || ""}`;
      }
      return "";
    },
  },
  methods: {
    onInput(event) {
      let value = event.target.value.replace(/\D/g, "");

      if (value.length > 2) {
        value = `${value.slice(0, 2)}-${value.slice(2)}`;
      }
      if (value.length > 5) {
        value = `${value.slice(0, 5)}-${value.slice(5, 9)}`;
      }

      const [day, month, year] = value.split("-");

      if (day && (day < 0 || day > 31) || day === "00") {
        value = "";
      } else if (month && (month < 0 || month > 12) || month === "00") {
        value = `${day || ""}-`;
      }

      event.target.value = value;

      if (day && month && year) {
        this.$emit("update:modelValue", `${year}-${month}-${day}`);
      } else {
        this.$emit("update:modelValue", "");
      }
    },
  },
};
</script>
